import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({ providedIn: "root" })
export class ReminderService {
    private dueReminders: any[] = [];
    private shownReminders = new Set<number>();

    setReminders(reminders: any[]) {
        // console.log(reminders);
        // console.log(this.shownReminders);
        
        
        this.dueReminders = reminders;
        this.shownReminders.clear();
    }

    getNextUnshownReminder(): any | null {
        return (
            this.dueReminders.find((r) => !this.shownReminders.has(r.id)) ||
            null
        );
    }

    markAsShown(id: number) {
        this.shownReminders.add(id);
    }

    isShown(id: number): boolean {      
        return this.shownReminders.has(id);
    }

    clear() {
        this.dueReminders = []
        this.shownReminders.clear();
    }
}
